import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requirePdf_worker_min } from "/vercel/path0/node_modules/.pnpm/pdfjs-dist@3.4.120/node_modules/pdfjs-dist/build/pdf.worker.min.js";
var pdf_worker_minExports = requirePdf_worker_min();
export { pdf_worker_minExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(pdf_worker_minExports);